import { render, staticRenderFns } from "./invite-company.vue?vue&type=template&id=1c0952f4&"
import script from "./invite-company.vue?vue&type=script&lang=js&"
export * from "./invite-company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports